module.exports = __webpack_public_path__ + "static/media/carta_18.39c5b38c.jpg";